import { FormItem, useFieldArrayOf } from '@framework/form';
import { Button, Card, Typography } from 'antd';
import { IReference } from '../../../../../../expressions/references/IReference';
import { IAsyncService } from '../../../../../../expressions/repository/async/context/IAsyncService';
import { IAsyncSelectWidget } from '../../IAsyncSelectWidget';
import { AsyncServiceInputConfigForm } from '../AsyncServiceInputConfigForm';
import { ServiceOutputSelect } from '../ServiceOutputSelect';
import { AsyncSelectServiceColumnConfig } from './AsyncSelectServiceColumnConfig';

export interface IAsynceSelectServiceTableConfigFormProps {
  selected: IAsyncService | null | undefined;
  hasInputs: boolean | undefined;
  references: IReference[];
  /**
   * Se  `true` mostra anche il campo per la configurazione del valore (e.g. AsyncSelectWidget),
   * altrimenti mostra solo la configurazione della tabella (e.g. AsyncTableWidget).
   */
  hasValue: boolean;
}

/**
 * Form di configurazione del servizio esterno per l'async select widget con visualizzazione
 * in tabella.
 */
export function AsynceSelectServiceTableConfigForm(
  props: IAsynceSelectServiceTableConfigFormProps,
) {
  const { selected, hasInputs, references, hasValue } = props;

  const columnsField = useFieldArrayOf<{ label: string; value: string }>({
    name: 'table.columns',
  });

  if (!selected) return null;

  return (
    <>
      <div style={{ paddingTop: '8px' }}>
        <Card size="small" title="Configura tabella">
          <Typography.Text type="secondary">
            Configura le colonne della tabella che verrà visualizzata. Per ogni
            colonna è possibile selezionare un campo di output del servizio, che
            verrà utilizzato come valore della colonna. Le colonne verranno
            visualizzate nell&apos;ordine in cui vengono configurate.
          </Typography.Text>
          <div style={{ paddingTop: '8px' }}>
            {columnsField.fields.map((c, i) => (
              <AsyncSelectServiceColumnConfig
                index={i}
                service={selected}
                onDelete={() => columnsField.remove(i)}
                key={c.id}
              />
            ))}
          </div>
          <Button
            onClick={() =>
              columnsField.append({
                label: '',
                value: '',
              })
            }
          >
            Aggiungi colonna
          </Button>
        </Card>
      </div>

      {hasValue && (
        <div style={{ paddingTop: '8px' }}>
          <Card size="small" title="Configura valore">
            <Typography.Text type="secondary">
              Seleziona l&apos;output del servizio che verrà utilizzato come
              valore per questo widget. Sarà possibile utilizzare il valore
              scelto nelle formule sia attraverso il riferimento al codice del
              campo, sia con il riferimento dedicato.
            </Typography.Text>
            <FormItem
              name="labelFields"
              help="Se vengono selezionati più campi, saranno mostrati separati da un '-' nell'ordine configurato"
            >
              <ServiceOutputSelect
                label="Etichetta Valore"
                service={selected}
                name="labelFields"
                mode="multiple"
              />
            </FormItem>
            <FormItem name="valueField">
              <ServiceOutputSelect
                label="Valore del campo"
                service={selected}
                name="valueField"
              />
            </FormItem>
          </Card>
        </div>
      )}

      {hasInputs && (
        <AsyncServiceInputConfigForm
          name="inputs"
          service={selected}
          references={references}
        />
      )}
    </>
  );
}
